<script setup lang="ts">
defineProps<{
  error?: string;
}>();

const model = defineModel<string | undefined>();

function handleInput(event: Event) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/\D/g, '');

  const maxLength = String(9999).length;
  if (input.value.length > maxLength) input.value = input.value.slice(0, maxLength);

  model.value = input.value;
}
</script>

<template>
  <div class="flex flex-col gap-1">
    <AFieldLabel
      required
      :error
      :label="$t('cart.label.lastFour')"
    />

    <InputText
      v-model="model"
      required
      type="text"
      :class="['h-9 w-full text-sm', { 'af-field-error': !!error }]"
      :placeholder="$t('cart.label.lastFourPlaceholder')"
      @input="handleInput"
    />
  </div>
</template>
